import React, { useState } from "react";
import { motion } from "framer-motion";
import "./appoiment.css";
import Header from "../../component/header/header";
import Footer from "../../component/footer/footer";

export const Appoiment = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    date: "",
    purpose: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' | 'error' | null

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch("https://api.chinmayushah.com/api/appointment", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          date: formData.date,
          purpose: formData.purpose,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setSubmitStatus("success");
        // Reset form
        setFormData({
          name: "",
          email: "",
          date: "",
          purpose: "",
        });
        // Show success message
        alert("✅ Appointment booked successfully! Check your email for confirmation.");
      } else {
        setSubmitStatus("error");
        alert("❌ Failed to book appointment. Please try again.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSubmitStatus("error");
      alert("❌ Network error. Please check your connection and try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <Header />

      <section className="appointment-section py-5 text-light" id="appointment">
        <div className="container">
          <motion.div
            className="text-center mb-5"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="display-6 fw-bold text-primary mb-3">
              Book an Appointment
            </h2>
            <p className="lead text-white-50">
              Choose your preferred date and time to schedule a meeting.
            </p>
          </motion.div>

          <motion.div
            className="row justify-content-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 1 }}
          >
            <div className="col-md-8 col-lg-6">
              <form
                className="p-4 rounded-4 shadow-lg bg-dark bg-opacity-75"
                onSubmit={handleSubmit}
              >
                {/* Name */}
                <div className="mb-3">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter your name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                {/* Email */}
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                {/* Purpose */}
                <div className="mb-3">
                  <label className="form-label">Purpose of Appointment</label>
                  <textarea
                    className="form-control"
                    placeholder="Briefly describe the purpose"
                    name="purpose"
                    rows="3"
                    value={formData.purpose}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                  />
                </div>

                {/* Date */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label className="form-label">Select Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={formData.date}
                      onChange={handleChange}
                      required
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <motion.button
                  whileHover={{ scale: isSubmitting ? 1 : 1.05 }}
                  whileTap={{ scale: isSubmitting ? 1 : 0.95 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  type="submit"
                  className="btn btn-primary w-100 py-2 mt-2 fw-semibold"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      Submitting...
                    </>
                  ) : (
                    "Confirm Appointment"
                  )}
                </motion.button>

                {/* Status indicator */}
                {submitStatus === "success" && (
                  <div className="alert alert-success mt-3" role="alert">
                    ✅ Appointment booked successfully!
                  </div>
                )}
                {submitStatus === "error" && (
                  <div className="alert alert-danger mt-3" role="alert">
                    ❌ Failed to book appointment. Please try again.
                  </div>
                )}
              </form>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Appoiment;